import {
  Component,
  ErrorInfo,
  PropsWithChildren,
  ReactNode,
} from 'react'
import { captureException } from '@pogokid/log'
import { DisplayEmpty } from '~m/AppUi/components/DisplayEmpty.tsx'
import { ButtonBasic } from '~m/designSystem'

interface ErrorBoundaryState {
  error: Error | null
}

/**
 * Catches render errors below it and shows the fallback instead of
 * a blank page. The error is recorded through `captureException`.
 */
export class ErrorBoundary extends Component<
  PropsWithChildren,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(
    error: Error
  ): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureException(error, {
      data: { componentStack: errorInfo.componentStack },
    })
  }

  render(): ReactNode {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <DisplayEmpty
        title="Sorry, we have hit an error"
        description={String(error)}
        actions={
          <ButtonBasic href="/dashboard">
            Goto Dashboard
          </ButtonBasic>
        }
      />
    )
  }
}
